module.exports = __webpack_public_path__ + "static/media/DrawerLogo.b657e03a.png";